import { Controller } from '@hotwired/stimulus';

import BulletChart, { BulletChartOptions, BulletChartSection } from '../graphs/bullet-chart';

export default class extends Controller {
  static targets = ['svg'];

  svgTarget: SVGElement;

  resizeListener: () => void;

  connect() {
    this.draw();
    this.connectResizeListener();
  }

  disconnect() {
    this.disconnectResizeListener();
  }

  draw() {
    const chart = new BulletChart(this.svgTarget, this.graphOptions);
    chart.draw();
  }

  connectResizeListener() {
    this.resizeListener = this.draw.bind(this) as () => void;
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectResizeListener() {
    window.removeEventListener('resize', this.resizeListener);
  }

  get graphOptions(): BulletChartOptions {
    return {
      // @ts-expect-error TS2322 violates strict null checks
      minLabel: this.data.get('min-label'),
      // @ts-expect-error TS2322 violates strict null checks
      maxLabel: this.data.get('max-label'),
      // @ts-expect-error TS2345 violates strict null checks
      measure: parseFloat(this.data.get('measure')),
      // @ts-expect-error TS2345 violates strict null checks
      sections: JSON.parse(this.data.get('sections')) as BulletChartSection[],
      // @ts-expect-error TS2322 violates strict null checks
      status: this.data.get('status'),
      // @ts-expect-error TS2345 violates strict null checks
      optionalMeasure: parseFloat(this.data.get('optional-measure')),
      // @ts-expect-error TS2322 violates strict null checks
      optionalMeasureLabel: this.data.get('optional-measure-label'),
    };
  }
}
